import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
export const Diff = ({ countDiff }) => {
    const { t } = useTranslation();
    return _jsx("div", { className: "text-nowrap", children: !countDiff ? ('') : countDiff > 0 ? (_jsxs("small", { className: "text-danger ml-1 mr-1 float-left", "data-testid": "diff-positive", children: ["(+", new Intl.NumberFormat(t('numberFormatLocale')).format(countDiff), ")"] })) : (_jsxs("small", { className: "text-success ml-1 mr-1 float-left", "data-testid": "diff-negative", children: ["(", new Intl.NumberFormat(t('numberFormatLocale')).format(countDiff), ")"] })) });
};
